import { render, staticRenderFns } from "./comp_dpc-CarouselMultiple.vue?vue&type=template&id=654c1445&scoped=true&"
import script from "./comp_dpc-CarouselMultiple.vue?vue&type=script&lang=js&"
export * from "./comp_dpc-CarouselMultiple.vue?vue&type=script&lang=js&"
import style0 from "./comp_dpc-CarouselMultiple.vue?vue&type=style&index=0&id=654c1445&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654c1445",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VRow,VTab,VTabItem,VTabs,VTabsItems})
